import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  static properties = {
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
    isUpsell: {
      type: Boolean,
      attribute: 'is-upsell',
    },
  }

  constructor() {
    super()

    this.onSubmitHandler = this.onSubmitHandler.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]')

    this.form.addEventListener('submit', this.onSubmitHandler)

    this.receiver = broadcastReceiver(`quantity-${this.form.getAttribute('id')}`, (...args) => {
      this.getQuantityFromDocument(...args)
    })

  }

  addToCartBundle = async (data) => {
    const BundleData = JSON.parse(data.properties['_bundle-data'])
    const BundlePrice = parseInt(data.properties['_bundle-price'])
    const BundleHandle = data.properties['_bundle-handle']
    const products = JSON.parse(BundleData)?.products

    let formData = { items: [] }
    let selectedProducts = products
      .map(({ id, sku }) => (id ? id : sku))
      .join('/')
    let kit_price_secret = BundlePrice + products.length
    kit_price_secret = kit_price_secret * BundleHandle.length - 78
    kit_price_secret = `10${products.length}${kit_price_secret}`

    // Add parent product to payload
    formData.items.push({
      id: data.id,
      quantity: data.quantity ? data.quantity : 1,
      properties: {
        _isParent: true,
        '_bundle-data': JSON.stringify(products),
        '_bundle-kids': selectedProducts,
        '_bundle-show': data.properties['_bundle-show'],
        _kit_price_secret: kit_price_secret,
      },
    })

    return await addToCart(formData)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.form.removeEventListener('submit', this.onSubmitHandler)

    this.receiver?.disconnect();
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  validateMaxQuantity(id) {
    const { maxQuantity, productId } = this.form.dataset
    if (!maxQuantity) return true
    const cartQuantity = document.querySelector(`.js-cart-item[data-id="${id}"] hh-quantity-input`)?._value || 0
    const addingQuantity = this.form.querySelector('hh-quantity-input')?._value || 1

    if (cartQuantity >= maxQuantity || addingQuantity > maxQuantity) {
      document.dispatchEvent(
        new CustomEvent(`DELAYED_MESSAGE:SHOW`, {
          detail: {
            id: `product-message-${productId}`,
            type: 'max-quantity'
          }
        })
      )
      return false
    }
    document.dispatchEvent(new CustomEvent(`DELAYED_MESSAGE:HIDE`))
    return true
  }

  showMessage(message) {
    const { productId } = this.form.dataset
    document.dispatchEvent(
      new CustomEvent(`DELAYED_MESSAGE:SHOW`, {
        detail: {
          id: `product-message-${productId}`,
          type: 'errors',
          message: message
        }
      })
    )
  }

  checkSubmission() {
    const { id } = JSON.parse(serializeForm(this.form))
    const maxValidate = this.validateMaxQuantity(id)

    return maxValidate
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    if (!this.checkSubmission()) return

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')

    const response = (this.form.hasAttribute('is-bundle')) ?
      await this.addToCartBundle(JSON.parse(serializeForm(this.form))) :
      await addToCart(JSON.parse(serializeForm(this.form)))

    if (this.isUpsell) {
      setTimeout(() => {
        this.enableATC()
      }, 3000);
    } else {
      this.enableATC()
    }
    if (response.errors) {
      this.showMessage(response.errors)
    } else {
      reRenderShopifySections(response)
      if (this.showMiniCartAfterSubmission && !this.isUpsell) {
        utils.toggle(document.body, ['mini-cart-is-active'])
        document.dispatchEvent(new CustomEvent('miniCartToggled'))
      }

      this.dispatchEvent(
        new CustomEvent('productAdded', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'cart-notification'
          },
        })
      )
    }

    if (this.isUpsell) {
      setTimeout(() => {
        this.enableATC()
      }, 3000);
    } else {
      this.enableATC()
    }
  }

  enableATC() {
    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
